<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="tit-wrap tit-wrap--unberline text-center pb-0px pb-md-20px">
                    <h2 class="tit tit--lg">회원가입</h2>
                </div>
                <div class="contents-area__inner">
                    <router-join />
                </div>
            </div>
        </v-container>
    </component>
</template>
<script>

import RouterJoin from "@/components/client/join/router-join.vue";

export default {
    components: {
        RouterJoin
    },
    mounted(){
        if(this.logon) this.$router.push("/");
    },
    computed: {
        template(){
            return () => import(`@/templates/${this.$theme.pages.default}`);
        },

        accessToken(){
            return this.$store.state.accessToken;
        },
        logon(){
            return !!this.accessToken;
        }
    }
}
</script>

<style scoped>
.v-stepper__header {
    font-size: 36px;
}
</style>